
export const createAgaroseRotorAdapters = (data) => ({
    type: "CREATE_ROTOR_ADAPTERS", payload: data
  });

  
//---ROTOR_ADAPTERS------------------------------------------:
export const createRotorAdapters = data => {
  //data = {id, description, type}
  return { type: "CREATE_ROTOR_ADAPTERS", payload: data };
};

export const setRotorAdapters = data => {
  //data = {type, concentration, description}
  return { type: "SET_ROTOR_ADAPTERS", payload: data };
};

export const setRotorAdaptersOnShelf = data => {
  //data = {id, onShelf}
  return { type: "SET_ROTOR_ADAPTERS_ON_SHELF", payload: data };
};

export const setRotorAdaptersInScene = data => {
  //data = {type, inScene}
  return { type: "SET_ROTOR_ADAPTERS_IN_SCENE", payload: data };
};

export const setRotorAdaptersHeld = data => {
  //data = {id, held}
  return { type: "SET_ROTOR_ADAPTERS_HELD", payload: data };
};


//Set whether the pipette controls are displayed or not
export const setRotorAdaptersControlVisibility = (data) => {
  //data = {id, animatingOut}
  return { type: "SET_ROTOR_ADAPTERS_CONTROLS_VISIBLE", payload: data}
}


